import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SignupModalService {
  private readonly open$ = new Subject<void>();

  /** Emits when the signup modal should open. */
  readonly onOpen = this.open$.asObservable();

  openModal(): void {
    this.open$.next();
  }
}
